
<template>
  <!--配置管理-->
  <div>
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
    </x-tabula>

    <!--新增配置的弹窗-->
    <a-modal
      :title="modalTitle"
      :visible="visible"
      @cancel="visible= false"
      @ok="$refs.addEdit.handleSubmit()"
      :confirmLoading="btnLoading.loading"
      v-bind="$store.state.modalConfig"
    >
      <x-addEdit
        ref="addEdit"
        formType="modal"
        :isSubmitBtn="false"
        :itemLayout="$store.state.modal_ItemLayout"
        :reqLoading="btnLoading"
        :formList="functionList"
        :formKey="formKey"
        :addParam="addParam"
        :editParam="editParam"
        :detailParam="detailParam"
      >
        <template slot="int" slot-scope="{formItem}">
          <a-form-item v-if="formItem.show" class="btn-gropu-gps" :label="formItem.label" required v-bind="$store.state.modal_ItemLayout">
            <a-input-group compact>
              <a-form-item v-for="(item, index) of formItem.subList" :key="index">
                <a-input v-decorator="item.props" :placeholder="item.placeholder"/>
              </a-form-item>
            </a-input-group>
          </a-form-item>
        </template>
        <template slot="float" slot-scope="{formItem}">
          <a-form-item v-if="formItem.show" class="btn-gropu-gps" :label="formItem.label" required v-bind="$store.state.modal_ItemLayout">
            <a-input-group compact>
              <a-form-item v-for="(item, index) of formItem.subList" :key="index">
                <a-input v-decorator="item.props" :placeholder="item.placeholder"/>
              </a-form-item>
            </a-input-group>
          </a-form-item>
        </template>

        <template slot="enum" slot-scope="{formItem}">
          <a-form-item class="enum-list" v-if="formItem.show" :label="formItem.label" required v-bind="$store.state.modal_ItemLayout">
            <template v-for="(item, index) of formItem.subList">
            <div v-show="!item.isHidden" :key="index">
              <div v-for="(el, order) of item.list" :key="order">
                <a-form-item :label="el.label" v-bind="{ labelCol: { span: 20 }, wrapperCol: { span: 24}}">
                  <a-input v-decorator="el.props" :placeholder="el.placeholder"/>
                </a-form-item>
              </div>
              <span class="delete" v-if="item.deleteBtn" @click="deleteHandle(formItem.subList, index)">
                <a-icon type="close-circle" />
              </span>
            </div>
            </template>
            <a-button class="add" @click="enumAdd" type="dashed" icon="plus" block>添加</a-button>
          </a-form-item>
        </template>

        <template slot="bool" slot-scope="{formItem}">
          <a-form-item v-if="formItem.show" :label="formItem.label" required v-bind="$store.state.modal_ItemLayout">
            <template v-for="(item, index) of formItem.subList">
              <a-form-item :label="item.label" :key="index" v-bind="{ labelCol: { span: 4 }, wrapperCol: { span: 12 } }">
                <a-input v-decorator="item.props" :placeholder="item.placeholder"/>
              </a-form-item>
            </template>
          </a-form-item>
        </template>

        <template slot="char" slot-scope="{formItem}">
          <a-form-item v-if="formItem.show" :label="formItem.label" required v-bind="$store.state.modal_ItemLayout">
              <a-input v-decorator="formItem.props" :placeholder="formItem.placeholder"/>
          </a-form-item>
        </template>

        <template slot="defaultVal" slot-scope="{formItem}">
          <a-form-item :label="formItem.label" v-bind="$store.state.modal_ItemLayout">
            <a-input v-decorator="formItem.props" :placeholder="formItem.placeholder"/>
          </a-form-item>
        </template>
      </x-addEdit>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect } from '@/utils/mixins';
export default {
  name: 'configManage',
  mixins: [fetchSelect],
  data () {
    return {
      propsIndex: 1,
      modalTitle: '新增配置',
      visible: false,
      btnLoading: { loading: false },
      functionList: [
        {
          label: '配置名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入配置名称',
          disabled: false,
          props: ['title', {
            rules: [{required: true, message: '请输入配置名称'}]
          }]
        },
        {
          label: '标识符',
          inputType: 'input',
          options: [],
          placeholder: '请输入标识符',
          disabled: false,
          props: ['unique', {
            rules: [{required: true, message: '请输入标识符'}]
          }]
        },
        {
          label: '数据类型',
          inputType: 'select',
          options: [],
          placeholder: '请选择数据类型',
          handle: this.dataTypeChange,
          disabled: false,
          props: ['valType', {
            rules: [{required: true, message: '请选择数据类型'}]
          }]
        },

        {
          slot: 'int',
          show: false,
          label: '取值范围',
          inputType: 'input',
          subList: [
            {
              inputType: 'input',
              placeholder: '最小值',
              props: ['min', {
                rules: [
                  { pattern: /^(0|[1-9][0-9]*|-[1-9][0-9]*)$/, message: '请输入整数' },
                  { required: true, message: '请输入最小值' }
                ]
              }]
            },
            {
              inputType: 'input',
              placeholder: '最大值',
              props: ['max', {
                rules: [
                  { pattern: /^(0|[1-9][0-9]*|-[1-9][0-9]*)$/, message: '请输入整数' },
                  { required: true, message: '请输入最大值' }
                ]
              }]
            }
          ]
        },
        {
          slot: 'float',
          show: false,
          label: '取值范围',
          inputType: 'input',
          subList: [
            {
              inputType: 'input',
              placeholder: '最小值',
              props: ['min', {
                rules: [
                  { pattern: /(^([-]?)[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^([-]?)(0){1}$)|(^([-]?)[0-9]\.[0-9]([0-9])?$)/, message: '小数不超过小数点后两位' },
                  { required: true, message: '请输入最小值' }
                ]
              }]
            },
            {
              inputType: 'input',
              placeholder: '最大值',
              props: ['max', {
                rules: [
                  { pattern: /(^([-]?)[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^([-]?)(0){1}$)|(^([-]?)[0-9]\.[0-9]([0-9])?$)/, message: '小数不超过小数点后两位' },
                  { required: true, message: '请输入最大值' }
                ]
              }]
            }
          ]
        },
        {
          slot: 'enum',
          show: false,
          label: '枚举',
          inputType: 'input',
          subList: [
            {
              deleteBtn: true,
              list: [
                {
                  label: '参数名',
                  inputType: 'input',
                  placeholder: '参数名',
                  props: ['label_1', {
                    rules: [{required: true, message: '请输入名称'}]
                  }]
                },
                {
                  label: '参数值',
                  inputType: 'input',
                  placeholder: '参数值',
                  props: ['value_1', {
                    rules: [{required: true, message: '请输入值'}]
                  }]
                }
              ]
            }
          ]
        },
        {
          slot: 'bool',
          show: false,
          label: '布尔值',
          inputType: 'input',
          subList: [
            {
              label: '0 - ',
              inputType: 'input',
              placeholder: '如: 关',
              props: ['close', {
                rules: [{required: true, message: '请输入值'}]
              }]
            },
            {
              label: '1 - ',
              inputType: 'input',
              placeholder: '如: 开',
              props: ['open', {
                rules: [{required: true, message: '请输入值'}]
              }]
            }
          ]
        },
        {
          slot: 'char',
          show: false,
          label: '数据长度',
          inputType: 'input',
          placeholder: '输入字符长度',
          props: ['valContent', {
            rules: [
              {pattern: /^[0-9]*[1-9][0-9]*$/, message: '请输入正整数'},
              {required: true, message: '请输入字符长度'}
            ]
          }]
        },

        {
          slot: 'defaultVal',
          label: '默认值',
          inputType: 'input',
          options: [],
          placeholder: '请输入默认值',
          props: ['val', {
            rules: [{required: true, message: '请输入默认值'}]
          }]
        }
      ],
      formKey: {
        title: undefined,
        unique: undefined,
        valType: undefined,
        min: undefined,
        max: undefined,
        open: undefined,
        close: undefined,
        label: undefined,
        value: undefined,
        val: undefined
      },
      addParam: {
        url: '/settings',
        reqHandle: this.reqHandle,
        resHandle: () => this.addEditResHandle('新增')
      },
      editParam: {
        url: '/settings/',
        resHandle: () => this.addEditResHandle('编辑')
      },
      detailParam: {
        url: '/settings/',
        resHandle: this.detailResHandle
      },

      searchList: [
        { props: ['keywords'], placeholder: '配置名称', options: [], inputType: 'input' }
      ],
      tableOptList: [
        { text: '新增', handle: this.openAddModal, icon: 'plus', permi: ['system:config:add'] }
      ],
      rowOptList: [
        { text: '修改', handle: row => this.editFun(row), permi: ['system:config:edit'] },
        { text: '删除', handle: row => this.$refs.table.showDeleteConfirm(row), permi: ['system:config:remove'] }
      ],
      columns: [
        { title: '配置名称', dataIndex: 'title', align: 'left', width: '' },
        { title: '标识符', dataIndex: 'unique', align: 'left', width: '' },
        { title: '数据类型', dataIndex: 'valType', align: 'left', width: '' },
        { title: '当前设置', dataIndex: 'val', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        keywords: undefined
      },
      listApi: {
        url: '/settings/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        title: ''
      },
      deleteParam: {
        url: '/settings/',
        // param: {pk_key: 'id', pk_val: ''},
        title: '配置',
        key: 'title'
      }
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  created () {
  },
  methods: {
    /** 获取数据类型下拉 */
    getSelect () {
      this.dictionarySelect([{index: 2, scope: 'functionList', query: 'data_type'}]);
    },
    // 添加编辑返回处理
    addEditResHandle (msg) {
      this.$message.success(`${msg}成功`);
      this.$refs.table.getTableList();
      this.visible = false;
    },
    /** 根据数据类型切换输入框 */
    dataTypeChange (val) {
      this.functionList.forEach((el) => {
        el.slot === val ? el.show = true : el.show = false;
      });
    },
    /* 打开弹窗 */
    openAddModal () {
      this.clearDefaultFomrValue();
      this.dataTypeChange();
      this.propsIndex = 1;
      this.visible = true;
      this.modalTitle = '添加配置';
      this.disableForm(false);
      this.$nextTick(() => {
        this.getSelect();
      });
    },
    // 清除表单的默认值
    clearDefaultFomrValue () {
      this.functionList.forEach(item => {
        if (item.slot === 'int' || item.slot === 'float' || item.slot === 'bool') {
          item.subList.forEach(item1 => {
            delete item1.props[1].initialValue;
          });
        } else if (item.slot === 'char') {
          delete item.props[1].initialValue;
        } else if (item.slot === 'enum') {
          item.subList = [
            {
              deleteBtn: true,
              list: [
                {
                  label: '参数名',
                  inputType: 'input',
                  placeholder: '参数名',
                  props: ['label_1', {
                    rules: [{required: true, message: '请输入名称'}]
                  }]
                },
                {
                  label: '参数值',
                  inputType: 'input',
                  placeholder: '参数值',
                  props: ['value_1', {
                    rules: [{required: true, message: '请输入值'}]
                  }]
                }
              ]
            }
          ];
        }
      });
    },
    // 获取二级数据类型的值
    getSecondValue (value, type) {
      let arr = [];
      for (let key in value) {
        arr.push(value[key]);
      }
      let itemArr = this.functionList.filter(item => {
        return type === item.slot;
      });
      itemArr = itemArr[0];
      if (type === 'int' || type === 'float') {
        itemArr.subList.forEach((item, index) => {
          item.props[1].initialValue = arr[index];
        });
      } else if (type === 'bool') {
        itemArr.subList[0].props[1].initialValue = arr[1];
        itemArr.subList[1].props[1].initialValue = arr[0];
      } else if (type === 'char') {
        itemArr.props[1].initialValue = +value;
      } else if (type === 'enum') {
        let tempArr = [];
        arr.forEach((item, index) => {
          tempArr.push({
            deleteBtn: true,
            list: [
              {
                label: '参数名',
                inputType: 'input',
                placeholder: '参数名',
                props: [`label_${index + 1}`, {
                  rules: [{required: true, message: '请输入名称'}],
                  initialValue: Object.keys(item)[0]
                }]
              },
              {
                label: '参数值',
                inputType: 'input',
                placeholder: '参数值',
                props: [`value_${index + 1}`, {
                  rules: [{required: true, message: '请输入值'}],
                  initialValue: Object.values(item)[0]
                }]
              }
            ]
          });
        });
        itemArr.subList = tempArr;
      }
    },
    /* 编辑功能 */
    editFun (row) {
      this.visible = true;
      this.modalTitle = '编辑功能';
      let tempValue = JSON.parse(row.valContent);
      this.getSecondValue(tempValue, row.valType);
      this.$nextTick(() => {
        this.$refs.addEdit.form.setFieldsValue({ ...row });
        this.dataTypeChange(row.valType);
        this.disableForm(true);

        this.$refs.addEdit.routeQuery = row.id;
        // this.$refs.addEdit.getDetail();
      });
    },
    /** 禁用或开启0、1、2三项 */
    disableForm (parm) {
      this.functionList.forEach((el, index) => {
        if ([0, 1, 2].some(item => item === index)) {
          el.disabled = parm;
        }
      });
    },
    /* 添加枚举类型项 */
    enumAdd () {
      let label = '参数名';
      let label2 = '参数值';
      let inputType = 'input';
      this.functionList.forEach((el) => {
        if (el.slot && el.slot === 'enum') {
          el.subList[0].deleteBtn = true;
          this.propsIndex += 1;
          el.subList.push({
            deleteBtn: true,
            list: [
              {
                label: label,
                inputType: inputType,
                placeholder: label,
                props: [`label_${this.propsIndex}`, {
                  rules: [{required: true, message: '请输入名称'}]
                }]
              },
              {
                label: label2,
                inputType: inputType,
                placeholder: label2,
                props: [`value_${this.propsIndex}`, {
                  rules: [{required: true, message: '请输入值'}]
                }]
              }
            ]
          });
        }
      });
    },
    /* 删除枚举类型项 */
    deleteHandle (list, index) {
      this.$set(list[index], 'isHidden', true);
      this.$refs.addEdit.form.setFieldsValue({
        [`label_${index + 1}`]: undefined,
        [`value_${index + 1}`]: undefined
      });
      console.log('getFields', index, this.$refs.addEdit.form.getFieldsValue());
      let list1 = list[index].list[0];
      let list2 = list[index].list[1];
      list1.props[1].rules[0].required = false;
      list2.props[1].rules[0].required = false;
      let showList = list.filter(item => item.isHidden !== true);
      if (showList.length === 1) {
        showList[0].deleteBtn = false;
      }
    },
    /* 表单提交前处理数据 */
    handleData (values) {
      let valType = values.valType;
      let enumValArr = [];
      if (valType === 'enum') {
        let enumArr = [];
        let labelArr = [];
        for (let item in values) { // label的"序号标识"组成为一个数组
          let itemArr = item.split('_');
          if (itemArr.length === 2 && itemArr[0] === 'label' && values[item]) {
            labelArr.push(itemArr[1]);
          }
        }
        console.log('labelArr: ', labelArr);

        labelArr.forEach(item => {
          let obj = {};
          for (let part in values) {
            let partArr = part.split('_');
            if (partArr[1] === item) { // 判断label和value的"序号标识"和labelArr的 每项相同
              if (partArr[0] === 'label') {
                obj[values[part]] = undefined; // label的值作为obj的key
                var key = values[part];
              }

              if (partArr[0] === 'value') {
                obj[key] = values[part]; // value的值作为obj的值
                enumValArr.push(values[part]);
              }
            }
          }
          enumArr.push(obj);
        });

        values.valContent = JSON.stringify(enumArr);
      } else if (valType === 'int' || valType === 'float') {
        let rangeObj = { min: '', max: '' };
        for (let item in rangeObj) {
          if (values.hasOwnProperty(item)) {
            rangeObj[item] = values[item];
          }
        }
        values.valContent = JSON.stringify(rangeObj);
      } else if (valType === 'bool') {
        let boolObj = { open: '', close: '' };
        for (let item in boolObj) {
          if (values.hasOwnProperty(item)) {
            boolObj[item] = values[item];
          }
        }
        values.valContent = JSON.stringify(boolObj);
      } else if (valType === 'char') {
        // values.valContent = JSON.stringify(values.valContent);
      }

      // 判断默认值范围
      let defaultVal = values.val;
      let content = JSON.parse(values.valContent);
      if (valType === 'int' || valType === 'float') {
        let min, max;
        for (let el in content) {
          if (el === 'min') {
            min = parseFloat(content[el]);
          } else if (el === 'max') {
            max = parseFloat(content[el]);
          }
        }
        if (min > max) {
          this.$message.error('最小值不可大于最大值');
          return;
        }
        if (parseFloat(defaultVal) < min || parseFloat(defaultVal) > max) {
          this.$message.error('默认值需在范围内');
          return;
        }
      } else if (valType === 'char') {
        if (String(defaultVal).length > parseInt(content)) {
          this.$message.error('默认值需在范围内');
          return;
        }
        // if (0 < parseFloat(defaultVal) && parseFloat(defaultVal) > parseInt(content)) {
        //   this.$message.error('默认值需在范围内');
        //   return;
        // }
      } else if (valType === 'bool') {
        if (+defaultVal !== 0 && +defaultVal !== 1) {
          this.$message.error('默认值需填0或1');
          return;
        }
      } else {
        let hasSomeVal;
        if (Array.isArray(content)) {
          hasSomeVal = enumValArr.some((el) => el === defaultVal);
        } else {
          let rangeVal = [];
          for (let item in content) {
            rangeVal.push(content[item]);
          }
          hasSomeVal = rangeVal.some((el) => el === defaultVal);
        }
        if (!hasSomeVal) {
          this.$message.error('默认值需在范围内');
          return;
        }
      }
      return values;
    },
    /** 提交前处理数据 */
    reqHandle (param) {
      let resParam = this.handleData(param);
      if (resParam) {
        return resParam;
      }
    },
    /** 处理获取详情数据 */
    detailResHandle (data) {
      let formValues = {};
      for (let item in data) {
        if (this.formKey.hasOwnProperty(item)) {
          formValues[item] = data[item];
        }
      }
      if (data.valType) {
        this.getSelect();
        let content = null;
        if (data.valContent) {
          content = JSON.parse(data.valContent);
        }
        if (typeof content === 'object') {
          if (!Array.isArray(content)) {
            formValues = Object.assign(formValues, content);
          } else {
            let obj = {};
            let arr = [];
            content.forEach((el, index) => {
              for (let i in el) { // 获取枚举列表的值
                obj[`value_${index + 1}`] = el[i];
                obj[`label_${index + 1}`] = i;
              }
              arr.push({ // 拼接formList列表
                deleteBtn: true,
                list: [
                  {
                    label: '参数名',
                    inputType: 'input',
                    placeholder: '参数名',
                    props: [`label_${index + 1}`, {
                      rules: [{ required: true, message: '请输入名称' }]
                    }]
                  },
                  {
                    label: '参数值',
                    inputType: 'input',
                    placeholder: '参数值',
                    props: [`value_${index + 1}`, {
                      rules: [{ required: true, message: '请输入值' }]
                    }]
                  }
                ]
              });
            });
            this.functionList.forEach((el) => {
              if (el.slot === 'enum') {
                // el.subList = arr;
              }
            });
            formValues = Object.assign(formValues, obj);
          }
        }
      }
      this.$nextTick(() => {
        this.formData = formValues;
      });
    }
  }
};
</script>
